
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from 'lucide-react';
import { TimeHorizon } from './index';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ALMTimelineSelectorProps {
  timeHorizons: TimeHorizon[];
  onAddTimeHorizon: () => void;
  onRemoveTimeHorizon?: (id: string) => void;
  granularity: "days" | "months";
  onGranularityChange: (value: "days" | "months") => void;
}

const ALMTimelineSelector = ({ 
  timeHorizons, 
  onAddTimeHorizon, 
  onRemoveTimeHorizon,
  granularity,
  onGranularityChange
}: ALMTimelineSelectorProps) => {
  return (
    <div className="bg-card border rounded-md p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold">Time Horizons</h3>
        <div className="flex items-center gap-3">
          <Select value={granularity} onValueChange={(value) => onGranularityChange(value as "days" | "months")}>
            <SelectTrigger className="w-[140px]">
              <SelectValue placeholder="Select granularity" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="days">Days</SelectItem>
              <SelectItem value="months">Months</SelectItem>
            </SelectContent>
          </Select>
          <Button variant="outline" size="sm" onClick={onAddTimeHorizon}>
            <Plus className="h-4 w-4 mr-1" />
            Add {granularity === "days" ? "Day" : "Month"}
          </Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {timeHorizons.map((horizon) => (
          <div 
            key={horizon.id}
            className="px-3 py-1 bg-secondary text-secondary-foreground rounded-md text-sm flex items-center justify-between"
          >
            <span>{horizon.label}</span>
            {onRemoveTimeHorizon && timeHorizons.length > 1 && (
              <button 
                onClick={() => onRemoveTimeHorizon(horizon.id)}
                className="ml-2 text-muted-foreground hover:text-destructive transition-colors"
              >
                <Trash2 className="h-3 w-3" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ALMTimelineSelector;
